export default __webpack_public_path__ + "static/media/microchip-red.7e576297.svg";